/**
 * Town View in local development: apply mutations to the FE store only (no API/DB writes).
 */
export const isDevelopmentEnvironment = () =>
  process.env.NODE_ENV === 'development' ||
  process.env.REACT_APP_ENV === 'development';

export const isTownViewDevNoPersist = (townView) =>
  Boolean(townView) && isDevelopmentEnvironment();
